import { render, staticRenderFns } from "./CreateUserNew.vue?vue&type=template&id=3dd4fa22"
import script from "./CreateUserNew.vue?vue&type=script&lang=js"
export * from "./CreateUserNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports